<template>
    <section>

        <swiper :options="swiperOption" ref="mySwiper" v-if="banList.length > 0">

            <swiper-slide v-for="(item, index) in bannerList" :data-url="item.tb_url" :key="index">
                <img :src="item.tb_image_url" class="banner-img cup" :data-url="item.tb_url" alt="">

            </swiper-slide>
            <!-- 底部分页 -->
            <div class="swiper-pagination df fdc jcc" slot="pagination"></div>
        </swiper>
    </section>
</template>
<script>

// 引入swiper文件
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// 接口
import { getBanner } from "@api/home";
export default {
    components: { Swiper, SwiperSlide },
    data() {
        return {
            banList: [
                { title: '1', img: require("@/assets/images/banner.png") },
                { title: '2', img: require("@/assets/images/banner.png") },
                { title: '3', img: require("@/assets/images/banner.png") },
            ],
            bannerList: [],

            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 6000, // 每6秒切换
                    disableOnInteraction: false, // 用户操作后是否禁用自动播放
                },
                // 显示分页
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, //允许分页点击跳转
                },
                on: {
                    slideChange: () => {
                        this.addDynamicCircles(); // 在切换时调用绘制圆圈的方法
                    },
                    click: (event) => {
                        this.handleLinke(event.target.getAttribute('data-url'));
                    }
                },
            },
        }
    },
    mounted() {
        // 轮播图分页的进度条
        this.$nextTick(() => {
            this.addDynamicCircles();
        });

        // 获取banner列表
        this.getBannerList();


    },
    methods: {
        // 跳转详情
        handleLinke(path) {
            if (path) {
                window.location.href = path;
            }
        },

        // 跳转详情
        handleLinke(path) {
            if (path) {
                window.location.href = path;
            }
        },

        // 获取banner信息
        async getBannerList() {
            let res = await getBanner({ dd_id: 10 });
            if (res.status == 200) {
                this.bannerList = res.data;
            }

        },
        // banner 轮播图分页的进度条
        addDynamicCircles() {
            // 清除之前的圆圈
            const existingCircles = document.querySelectorAll('.swiper-pagination-bullet svg');
            existingCircles.forEach(circle => {
                circle.remove();
            });
            const bullets = document.querySelectorAll('.swiper-pagination-bullet-active');
            bullets.forEach(bullet => {
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.setAttribute("width", "18");  // 修改宽度为 18
                svg.setAttribute("height", "18"); // 修改高度为 18
                svg.setAttribute("role", "img");
                svg.setAttribute("aria-label", "动态圆圈");
                const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                circle.setAttribute("cx", "9");   // 圆心 x 坐标调整为 9
                circle.setAttribute("cy", "9");   // 圆心 y 坐标调整为 9
                circle.setAttribute("r", "8");    // 半径调整为 8
                circle.setAttribute("stroke", "#ffffff");
                circle.setAttribute("stroke-width", "1");
                circle.setAttribute("fill", "none");
                circle.classList.add('circle');
                svg.appendChild(circle);
                bullet.appendChild(svg);
                // 动画效果
                circle.style.strokeDasharray = '50.24'; // 圆的周长
                circle.style.strokeDashoffset = '50.24'; // 初始偏移量
                circle.style.animation = 'draw 6s forwards'; // 动画效果
                circle.style.transform = 'rotate(180deg) scale(-1, 1)'; // 旋转180度并左右翻转
                circle.style.transformOrigin = 'center'; // 旋转中心为圆心
            });
        },

    }

}

</script>
<style lang="scss" scoped>
.swiper-container {
    height: 480px;

    .banner-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.swiper-pagination {
    width: 16px;
    padding-top: 18px;
    left: auto;
    right: 42px;
    top: 0;

    .swiper-pagination-bullet {}
}

::v-deep() {
    .swiper-pagination .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        background: #ffffff;
        margin: 8px 0;
        opacity: 0.6;
    }

    .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
        opacity: 1;

    }
}
</style>
<style lang="css">
.swiper-pagination svg {
    position: relative;
    left: -4px;
    top: -4px;
}

@keyframes draw {
    to {
        stroke-dashoffset: 0;
        /* 动画结束时，偏移量为0，表示圆圈被完全绘制 */
    }
}
</style>
